<template>
    <div class="introductionWrap">
        <div class="intrBox">
            <h3>上海隧道OA系统教培门户简介</h3>
            <div class="intrCont">
                <p>二零二零年初，新型冠状病毒狂嚣肆扰。在党中央领导下，以湖北武汉为重点的全民疫情防控阻击战全面迅速打响。隧道人在公司党委带领下，按照党中央、国务院、上海市委市政府、国资委和隧道股份的决策部署，快速响应、迅速布置、认真防控，体现国企高度责任意识担当精神。</p>
                <p>公司党委书记、董事长李波强调指出——“疫情当前，我们必须要做到防疫复工两手抓两手硬，在确保安全防疫的前提下有序复工。2020年是上海隧道的突破年，我们的工作目标是站得更高，练得更强，走得更远，我们要在提升核心竞争力、提升内部精细化管理水平以及扩大经营领域和地域这三个方面的目标方向发展。”</p>
                <p>人力资源部遵照公司党委统一部署，紧紧围绕三大目标方向发展总体要求，因地制宜整合公司内外资源、发挥公司专业领域人才优势，在标准与信息化小组的全力支持下，因势而动，迅速推出“上海隧道OA系统教培门户”项目。通过线上学习、视频点播、培训直播、学习管理、课程制作等功能，实现公司知识体系梳理、内部课程开发，同时有效缓解集中培训的工学矛盾，降低培训实施的直接、间接成本，实现培训的便捷性和即时性，提供跨区域培训实施的新方式，为有序克服疫情造成的暂时困难和不利局面助力支招，为圆满完成“2020上海隧道突破年”既定目标提供有力的支撑和坚实的保障。</p>
                <p>受疫情影响，“上海隧道OA系统教培门户”在短时间内开通上线，恳请您将使用平台的体验和建议告知我们，以便我们进一步改进和完善。 </p>
                <p>2020.03.15</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  data() {
    return {

    }
  }
}
</script>

<style scoped lang="less">
@media screen and (min-width: 320px) and (max-width: 1024px) {
    .introductionWrap{
        padding: 0 17px;
        background-color: #fff;
    }
}
@media screen and (min-width: 1445px) {
    .intrBox{
        width: 1200px;
        margin: 45px auto 40px;
        background: #FFFFFF;
        border-radius: 16px;
        padding: 50px 100px;
    }
    .introductionWrap{
        background-color: #fafafa;
    }
}
@media screen and (min-width: 1029px) and (max-width: 1440px){
    .intrBox{
        width: 1100px;
        margin: 45px auto 40px;
        background: #FFFFFF;
        border-radius: 16px;
        padding: 50px 100px;
    }
    .introductionWrap{
        background-color: #fafafa;
    }
}
// 公共
.introductionWrap{
    width: 100%;
    overflow: hidden;
    h3{
        font-size: 24px;
        line-height: 124px;
        text-align: center;
        border-bottom: 2px  solid #fafafa;
    }
    .intrCont{
        margin-bottom: 86px;
        p{
            font-size: 14px;
            color: rgba(25,25,26,0.80);
            letter-spacing: 1px;
            line-height: 40px;
            text-indent: 30px;
            &:last-child{
                text-align: right;
                margin-top: 50px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/PlatformIntroduction.vue